module.exports = __webpack_public_path__ + "media/images/background-4011c7ff29fa8ea8dd0614d0d7833891.jpg";